/*
 *   File : change-pin.js
 *   Author : https://evoqins.com
 *   Description : File to edit pin
 *   Integrations : 
 *   Version : 1.0.0
*/

import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

// Components
import { PrimaryButton, TextButton } from "../../Component/Buttons";
import { CustomPhoneInput, OTPInput } from "../../Component/FormElements";
import { Icon } from "../../Component/Icon";
import { ProfileCard } from "../../Component/Cards";
import { _scrollToTop } from "../../Helper";

function ChangePin() {

    const navigate = useNavigate();
    const inputRef = useRef(null);
    const currentMPINRef = useRef(null);
    const newMPINRef = useRef(null);
    const confirmNewMPINRef = useRef(null);

    // Otp 
    const [currentMPIN, setCurrentMPIN] = useState("");
    const [currentMPINError, setCurrentMPINError] = useState("");
    const [focusCurrentMPIN, setFocusCurrentMPIN] = useState(2);

    const [newMPIN, setNewMPIN] = useState("");
    const [newMPINError, setNewMPINError] = useState("");
    const [focusNewMPIN, setFocusNewMPIN] = useState(0);

    const [confirmMPIN, setConfirmMPIN] = useState("");
    const [confirmMPINError, setConfirmMPINError] = useState("");
    const [focusConfirmMPIN, setFocusConfirmMPIN] = useState(0);

    const [isForgetPin, setIsForgetPin] = useState(false);
    const [forgetPINStep, setForgetPINStep] = useState(1);
    const [number, setNumber] = useState("");
    const [numberError, setNumberError] = useState("");

    // Otp 
    const [otpValue, setOtpValue] = useState("");
    const [otpValueError, setOtpValueError] = useState("");
    const [focusedInput, setFocusedInput] = useState(2);

    useEffect(() => {
        // Scroll the page to top
        _scrollToTop();
    }, []);


    //handle change MPIN
    const _handleChangeMPIN = (value) => {
        setCurrentMPIN(value);
        setCurrentMPINError("");
        if (value.length === 4 && newMPIN.length < 4) {
            setFocusCurrentMPIN(0);
            setFocusNewMPIN(2);
        }
    };

    //handle change New MPIN
    const _handleChangeNewMPIN = (value) => {
        setNewMPIN(value);
        setNewMPINError("");

        if (value.length === 4 && confirmMPIN.length < 4) {
            setFocusNewMPIN(0);
            setFocusConfirmMPIN(2);
        }
    };

    //handle change confirm MPIN
    const _handleChangeConfirmNewMPIN = (value) => {
        setConfirmMPIN(value);
        setConfirmMPINError("");
    };

    // handle update pin
    const _handleUpdateMPIN = () => {
        if (newMPIN !== confirmMPIN) {
            setConfirmMPINError("PIN does not match");
        } else {
            navigate(-1);
        }
    };



    // FORGET MPIN FLOW //

    // handle resend OTP 
    const _handleForgetMPIN = () => {
        setIsForgetPin(true);
        setConfirmMPINError("");
        setNewMPIN("");
        setNewMPINError("");
        setConfirmMPIN("");
        setConfirmMPINError("");
    };

    const _handleUpdateForgetPINStep = () => {
        if (forgetPINStep == 1) {
            setIsForgetPin(false);
            setCurrentMPIN("");
            setCurrentMPINError("");
            setNewMPIN("");
            setNewMPINError("");
            setConfirmMPIN("");
            setConfirmMPINError("");
            setFocusCurrentMPIN(2);
        } else {
            setForgetPINStep((prev) => prev - 1);
        }
    };

    // handle phone input change
    const _handlePhoneChange = (value) => {
        if (value.length <= 10) {
            setNumber(value);
            setNumberError("");
        }
    };

    // handle validate input and trigger OTP
    const _handleGetOtp = () => {

        let is_valid = true;
        let validate_number = /^[6-9]\d{9}$/;

        if (number.trim().length === 0) {
            setNumberError("Enter your number");
            is_valid = false;
        } else if (!validate_number.test(number)) {
            setNumberError("Enter a valid phone number");
            is_valid = false;
        }

        if (is_valid) {
            setForgetPINStep(2); //OTP input
            setOtpValue("");
            setFocusedInput(2);
        }
    };

    //handle Otp change
    const _handleChangeOTP = (value) => {
        setOtpValue(value);
        setOtpValueError("");
    };

    // handle resend OTP 
    const _handleResendOtp = () => {
        setOtpValue("");
        setFocusedInput(2);
    };

    // handle verify OTP 
    const _handleVerifyOTP = () => {
        if (otpValue.length < 4) {
            setOtpValueError("Please provide received otp");
            setFocusedInput(2);
            return;
        }

        setForgetPINStep(3);
        setFocusNewMPIN(2);

    };


    return (
        <div className="row mb-4">
            <div className="col-12">
                <TextButton name="Change MPIN"
                    icon={true}
                    type={2}
                    onPress={() => navigate(-1)} />
            </div>

            <div className="row mt-4 pe-0 flex-column flex-md-row gap-3 gap-md-0">
                <div className="order-2 order-md-1 col-12 col-md-7 pe-0 pe-sm-auto">
                    {
                        isForgetPin == false ?
                            <div className="p-3 card-box-shadow e-bg-white min-vh-100">
                                <OTPInput label="Enter current MPIN"
                                    require
                                    ref={currentMPINRef}
                                    value={currentMPIN}
                                    spellCheck="false"
                                    error={currentMPINError}
                                    focused_input={focusCurrentMPIN}
                                    onFocus={() => setFocusCurrentMPIN(2)}
                                    onBlur={() => setFocusCurrentMPIN(0)}
                                    onChange={_handleChangeMPIN} />
                                <p className='e-text-sonic-silver my-3 mb-3 e-font-12 e-alt-font-lato line-height-18px e-font-weight-400'>
                                    Forgot MPIN?
                                    <span className='ps-1 e-text-primary-color e-font-weight-400 cursor-pointer text-decoration-hover-underline'
                                        onClick={_handleForgetMPIN}>
                                        Need Help
                                    </span>
                                </p>

                                <OTPInput label="Set new 4-digit MPIN"
                                    require
                                    ref={newMPINRef}
                                    value={newMPIN}
                                    spellCheck="false"
                                    error={newMPINError}
                                    focused_input={focusNewMPIN}
                                    onFocus={() => setFocusNewMPIN(2)}
                                    onBlur={() => setFocusNewMPIN(0)}
                                    onChange={_handleChangeNewMPIN} />

                                <OTPInput label="Re-enter 4-digit MPIN"
                                    wrapperClass="mt-4 mb-1"
                                    require
                                    ref={confirmNewMPINRef}
                                    value={confirmMPIN}
                                    spellCheck="false"
                                    error={confirmMPINError}
                                    focused_input={focusConfirmMPIN}
                                    onFocus={() => setFocusConfirmMPIN(2)}
                                    onBlur={() => setFocusConfirmMPIN(0)}
                                    onChange={_handleChangeConfirmNewMPIN} />

                                <PrimaryButton name="Update MPIN"
                                    fontSize="e-font-14-res e-font-16"
                                    className="col-12 col-sm-10 mt-4"
                                    onPress={_handleUpdateMPIN} />

                            </div>
                            :
                            <div className="p-3 card-box-shadow e-bg-white">
                                {/* Back button */}
                                <Icon icon="left-arrow"
                                    className="cursor-pointer mb-2"
                                    size="18px"
                                    color="#523FC0"
                                    onClick={_handleUpdateForgetPINStep} />
                                {
                                    forgetPINStep === 1 &&
                                    <>

                                        <CustomPhoneInput label="Phone number"
                                            placeholder="Enter your phone number"
                                            type="text"
                                            require
                                            autoFocus={false}
                                            value={number}
                                            error={numberError}
                                            className="w-100"
                                            wrapperClass="col col-sm-10"
                                            handleChange={_handlePhoneChange} />

                                        <PrimaryButton name="Get OTP"
                                            fontSize="e-font-14-res e-font-16"
                                            className="mt-4 col-12 col-sm-10"
                                            onPress={_handleGetOtp} />
                                    </>
                                }
                                {
                                    forgetPINStep === 2 &&
                                    <>
                                        <OTPInput label="Enter OTP"
                                            require
                                            ref={inputRef}
                                            value={otpValue}
                                            spellCheck="false"
                                            error={otpValueError}
                                            focused_input={focusedInput}
                                            onFocus={() => setFocusedInput(2)}
                                            onBlur={() => setFocusedInput(0)}
                                            onChange={_handleChangeOTP} />
                                        <p className='e-text-sonic-silver mb-4 mt-3 e-font-12 e-alt-font-lato line-height-18px e-font-weight-400'>
                                            Didn't receive OTP?
                                            <span className='ps-1 e-text-primary-color e-font-weight-400 cursor-pointer text-decoration-hover-underline'
                                                onClick={_handleResendOtp}>
                                                Resend OTP
                                            </span>
                                        </p>

                                        <PrimaryButton name="Continue"
                                            className="col-12 col-sm-10"
                                            fontSize="e-font-14-res e-font-16"
                                            onPress={_handleVerifyOTP} />
                                    </>
                                }
                                {
                                    forgetPINStep === 3 &&
                                    <>
                                        <OTPInput label="Set new 4-digit MPIN"
                                            require
                                            ref={newMPINRef}
                                            value={newMPIN}
                                            spellCheck="false"
                                            error={newMPINError}
                                            focused_input={focusNewMPIN}
                                            onFocus={() => setFocusNewMPIN(2)}
                                            onBlur={() => setFocusNewMPIN(0)}
                                            onChange={_handleChangeNewMPIN} />

                                        <OTPInput label="Re-enter 4-digit MPIN"
                                            wrapperClass="mt-4 mb-1"
                                            require
                                            ref={confirmNewMPINRef}
                                            value={confirmMPIN}
                                            spellCheck="false"
                                            error={confirmMPINError}
                                            focused_input={focusConfirmMPIN}
                                            onFocus={() => setFocusConfirmMPIN(2)}
                                            onBlur={() => setFocusConfirmMPIN(0)}
                                            onChange={_handleChangeConfirmNewMPIN} />

                                        <PrimaryButton name="Submit"
                                            fontSize="e-font-14-res e-font-16"
                                            className="col-12 col-sm-10 mt-4"
                                            onPress={_handleUpdateMPIN} />
                                    </>
                                }
                            </div>
                    }
                </div>
                <div className="order-1 order-md-2 col-12 col-sm-8 col-md-5 pe-0">
                    <ProfileCard navigate={true} />
                </div>
            </div>

        </div>
    )
}

export default ChangePin